import set from 'lodash/set';
import { FORM_ERROR as FORM_ERROR_KEY } from 'final-form';
import { HTTP_CODE_UNPROCESSABLE_ENTITY } from '../constants/system/http-codes';
import { REGEXP_TEMPLATE_FORM_BRACKET_NUMBERS } from '../constants/system/regexp-templates';
import FORM_KEY_PREFIX_INDEX from '../constants/system/form-key-prefixes';

export default class ErrorFormatService {
  public static FORM_ERROR: string = FORM_ERROR_KEY;

  public static formatGraphQLErrors(error: GraphQLServerError): FormErrorInstance | null {
    if (!this.isFormError(error)) {
      return null;
    }

    const serverError: GraphQLServerErrorInstance = error.graphQLErrors && error.graphQLErrors[0];

    let errorResponse: Record<string, string> = {
      [this.FORM_ERROR]: serverError.message,
    };

    const serverErrorFields: GraphQLServerErrorField[] = serverError.fields;

    if (serverErrorFields && serverErrorFields.length) {
      errorResponse = serverErrorFields.reduce((
        errorResponseValue: Record<string, string>, field: GraphQLServerErrorField,
      ): Record<string, string> => {
        set(errorResponseValue, this.formatFieldPath(field.path), field.message);

        return errorResponseValue;
      }, errorResponse);
    }

    return errorResponse;
  }

  public static formatGraphQLMainError(error: GraphQLServerError): FormErrorInstance | null {
    if (this.isFormError(error)) {
      return null;
    }

    const serverError: GraphQLServerErrorInstance = error.graphQLErrors && error.graphQLErrors[0];

    return {
      [this.FORM_ERROR]: serverError.message,
    };
  }

  public static getGraphQLErrorInstance(error: GraphQLServerError): ServerError | null {
    const serverError: ServerError = error.graphQLErrors && error.graphQLErrors[0];

    if (serverError) {
      return serverError;
    }

    return null;
  }

  public static isFormError(error: GraphQLServerError): boolean {
    const serverError: GraphQLServerErrorInstance = error.graphQLErrors && error.graphQLErrors[0];

    if (!serverError) {
      return false;
    }

    return !!serverError.fields && !!serverError.statusCode
      && serverError.statusCode === HTTP_CODE_UNPROCESSABLE_ENTITY;
  }

  public static getMainServerFormError(serverFormErrors: Record<string, string>): string | null {
    return (serverFormErrors && serverFormErrors[this.FORM_ERROR]) || null;
  }

  private static formatFieldPath(fieldPath: string): string {
    return fieldPath.replace(REGEXP_TEMPLATE_FORM_BRACKET_NUMBERS, `[${FORM_KEY_PREFIX_INDEX}-$1]`);
  }
}
